import React from 'react'
import PropTypes from 'prop-types'
import {
  getMuscleUsageMapExerciseUtil,
  MUSCLE_MESSAGE
} from '@gymaholic/packages'
import MusclesAnatomy from 'components/MusclesAnatomy'
import PageSubTitle from 'components/Page/Page.SubTitle'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useIntl from 'modules/component/utils/hooks/useIntl'
import ExerciseChip from 'pages/Exercise/components/Chip'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  muscleWorked: {
    id: 'Exercise.muscleWorked',
    defaultMessage: 'Muscle worked'
  }
})

export function ExerciseMuscles ({
  muscles,
  exercise
}) {
  const intl = useIntl()

  return (
    <View mt={2}>
      <PageSubTitle style={{ marginBottom: 0 }}>
        {formatMessageIntlUtil(intl, messages.muscleWorked)}
      </PageSubTitle>
      <View
        row
        mt='10px'
        mb
        style={{ flexWrap: 'wrap' }}
        jc
      >
        {muscles.map((muscle, index) => (
          <ExerciseChip
            key={index}
            text={formatMessageIntlUtil(intl, MUSCLE_MESSAGE[muscle])}
          />
        ))}
      </View>
      <MusclesAnatomy
        musclesUsageMap={getMuscleUsageMapExerciseUtil(exercise)}
        height={150}
      />
    </View>
  )
}

ExerciseMuscles.propTypes = {
  muscles: PropTypes.array.isRequired,
  exercise: PropTypes.object.isRequired
}
